import { useNavigate } from 'react-router-dom'

import Logo from '../../../ui/logo/Logo'
import SideNavContent from './sideNavContent/SideNavContent'

const SideNav = () => {
  const navigate = useNavigate()

  const goTo = (path: string) => {
    navigate(path)
  }

  return (
    <aside className="ph-side d-none d-lg-flex">
      <Logo to="/dashboard" />
      <SideNavContent onNavigate={goTo} />
    </aside>
  )
}

export default SideNav
